import React from 'react';
import { Card, Row, Col, Button } from 'react-bootstrap';
import './TopProject.css';
import { useHistory } from 'react-router-dom';
import { motion } from 'framer-motion';


const TopProject = (props) => {
  const { project } = props;

  let history = useHistory();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 3 }}
    >
      <Row xs={1} md={2} className='gy-4'>
        <Col className='mt-5'>
          <Card
            className='bg-dark text-white h-100 card shadow bg-body'
            style={{ borderRadius: '15px' }}
          >
            <Card.Img
              src={project?.imgHome}
              alt='Card image'
              style={{ height: '400px', borderRadius: '15px' }}
              className='image-fluid'
            />
          </Card>
        </Col>
        <Col className='pt-4'>
          <h2 className='text-white pb-4 pt-3'>{project?.name}</h2>
          <h4 className='text-white pb-3 fw-light '>
            {project?.shortDescription}
          </h4>
          <h5 className='text-white pb-4'>
            <span className='text-white fw-bold'>Technology: </span>
            {project?.technology}
          </h5>
          <Button
            variant='danger fw-bold'
            size='lg'
            className='me-2'
            onClick={() => history.push(`/projectDetail/${project.id}`)}
          >
            Details
          </Button>{' '}
        </Col>
      </Row>
    </motion.div>
  );
};

export default TopProject;
